var _a, _b;
import { __assign } from "tslib";
import { optionsMap } from 'pro-gallery-lib';
import React from 'react';
import { PRIVATE_CONTROLLERS } from './private-controllers';
import { ExternalMasterInfoOption, InternalMasterInfoOption } from './private-controllers/controllers/info';
export var processProGalleryOptions = function (options) { return (__assign(__assign({}, Object.values(GalleryOptions).reduce(function (defaults, option) {
    var _a;
    return (__assign(__assign({}, defaults), (_a = {}, _a[option.key] = option.default, _a)));
}, {})), options)); };
var EditorSections = {
    LAYOUT: {
        key: 'LAYOUT',
        title: 'Choose a Layout',
        type: 'SECTION',
    },
    IMAGE_DISPLAY: {
        key: 'IMAGE_DISPLAY',
        title: 'Image Display',
        type: 'SECTION',
    },
    DESIGN_SETTINGS: {
        key: 'DESIGN_SETTINGS',
        title: 'Design Settings',
        type: 'SECTION',
    },
    MEDIA_PERMISSION: {
        key: 'MEDIA_PERMISSION',
        title: 'Media Permissions',
        type: 'SECTION',
    },
    SLIDESHOW_SETTINGS: {
        key: 'SLIDESHOW_SETTINGS',
        title: 'Slideshow Settings',
        type: 'SECTION',
    },
    INFO_SETTINGS: {
        key: 'INFO_SETTINGS',
        title: 'Info Settings',
        type: 'SECTION',
    },
    ADVANCED: {
        key: 'ADVANCED',
        title: 'Advanced',
        type: 'SECTION',
    },
    OVERLAY: {
        key: 'OVERLAY',
        title: 'Overlay',
        type: 'SECTION',
    },
    IMAGE_LOADING: {
        key: 'IMAGE_LOADING',
        title: 'Image Loading',
        type: 'SECTION',
    },
    VIDEO: {
        key: 'VIDEO',
        title: 'Video Settings',
        type: 'SECTION',
    },
    // FULLSCREEN
    FULLSCREEN_INFO_SETTINGS: {
        key: 'FULLSCREEN_INFO_SETTINGS',
        title: 'Info Settings',
        type: 'SECTION',
    },
    FULLSCREEN_VIEWING_SETTINGS: {
        key: 'FULLSCREEN_VIEWING_SETTINGS',
        title: 'Viewing Settings',
        type: 'SECTION',
    },
    FULLSCREEN_BACKGROUND_FILTERS: {
        key: 'FULLSCREEN_BACKGROUND_FILTERS',
        title: 'Background Filters',
        type: 'SECTION',
    }
};
export var GalleryOptions = (_a = {},
    _a[optionsMap.layoutParams.structure.galleryLayout] = {
        key: optionsMap.layoutParams.structure.galleryLayout,
        title: 'ProGallery_Layout_Tab_Custom_Label',
        // description: 'ProGallery_Layout_Tab_Custom_Description',
        noBottomDivider: true,
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        options: [
            {
                value: 0,
                title: 'ProGallery_Layout_Layouts_Type12',
                icon: require('../assets/layouts/collage.svg').ReactComponent,
            },
            {
                value: 1,
                title: 'ProGallery_Layout_Layouts_Type13',
                icon: require('../assets/layouts/masonry.svg').ReactComponent,
            },
            {
                value: 2,
                title: 'ProGallery_Layout_Layouts_Type3',
                icon: require('../assets/layouts/grid.svg').ReactComponent,
            },
            {
                value: 3,
                title: 'ProGallery_Layout_Layouts_Type7',
                icon: require('../assets/layouts/thumbnail.svg').ReactComponent,
            },
            {
                value: 4,
                title: 'ProGallery_Layout_Layouts_Type8',
                icon: require('../assets/layouts/slider.svg').ReactComponent,
            },
            {
                value: 5,
                title: 'ProGallery_Layout_Layouts_Type9',
                icon: require('../assets/layouts/slideshow.svg').ReactComponent,
            },
            {
                value: 6,
                title: 'ProGallery_Layout_Layouts_Type10',
                icon: require('../assets/layouts/strip.svg').ReactComponent,
            },
            {
                value: 7,
                title: 'ProGallery_Layout_Layouts_Type6',
                icon: require('../assets/layouts/column.svg').ReactComponent,
            },
            {
                value: 10,
                title: 'ProGallery_Layout_Layouts_Type14',
                icon: require('../assets/layouts/bricks.svg').ReactComponent,
            },
            {
                value: 11,
                title: 'ProGallery_Layout_Layouts_Type15',
                icon: require('../assets/layouts/mix.svg').ReactComponent,
            },
            {
                value: 12,
                title: 'ProGallery_Layout_Layouts_Type16',
                icon: require('../assets/layouts/alternate.svg').ReactComponent,
            },
        ],
        default: 0,
    },
    _a[optionsMap.layoutParams.structure.scrollDirection] = {
        key: optionsMap.layoutParams.structure.scrollDirection,
        title: 'Native_ProGallery_Layout_Orientation_Label',
        type: 'OPTIONS',
        controller: 'RADIO',
        default: 'VERTICAL',
        options: [
            {
                value: 'VERTICAL',
                title: 'ProGallery_Layout_DisplaySection_Option1',
            },
            {
                value: 'HORIZONTAL',
                title: 'ProGallery_Layout_DisplaySection_Option2',
            },
        ],
    },
    _a[optionsMap.layoutParams.structure.layoutOrientation] = {
        key: optionsMap.layoutParams.structure.layoutOrientation,
        controller: 'RADIO',
        title: 'ProGallery_Layout_DisplaySection_Orientation_SubHeader',
        // description:
        //   'ProGallery_Layout_DisplaySection_Orientation_Tooltip',
        options: [
            {
                value: 'VERTICAL',
                title: 'ProGallery_Layout_DisplaySection_Orientation_Option1',
            },
            {
                value: 'HORIZONTAL',
                title: 'ProGallery_Layout_DisplaySection_Orientation_Option2',
            },
        ],
        type: 'OPTIONS',
        default: 'VERTICAL',
    },
    _a[optionsMap.behaviourParams.gallery.layoutDirection] = {
        key: optionsMap.behaviourParams.gallery.layoutDirection,
        title: 'ProGallery_Layout_Layout_Direction_Label',
        controller: 'RADIO',
        type: 'OPTIONS',
        default: 'LEFT_TO_RIGHT',
        options: [
            {
                value: 'LEFT_TO_RIGHT',
                title: 'ProGallery_Layout_Layout_Direction_LTR',
            },
            {
                value: 'RIGHT_TO_LEFT',
                title: 'ProGallery_Layout_Layout_Direction_RTL',
            },
        ],
    },
    _a[optionsMap.layoutParams.structure.itemSpacing] = {
        key: optionsMap.layoutParams.structure.itemSpacing,
        title: 'ProGallery_Layout_Spacing',
        // description: 'ProGallery_Layout_Spacing_Tooltip',
        type: 'NUMBER',
        min: 0,
        max: 300,
        step: 1,
        default: 10,
    },
    _a[optionsMap.layoutParams.structure.numberOfGridRows] = {
        key: optionsMap.layoutParams.structure.numberOfGridRows,
        title: 'ProGallery_Layouts_Columns_Column_Label',
        // description:
        // 'ProGallery_Layouts_Columns_Column_Tooltip',
        default: 1,
        max: 3,
        min: 1,
        type: 'NUMBER',
    },
    _a[optionsMap.layoutParams.structure.numberOfColumns] = {
        key: optionsMap.layoutParams.structure.numberOfColumns,
        title: 'ProGallery_Layout_Layouts_Gallery_Row_Label',
        // description:
        //   'ProGallery_Layout_Layouts_Gallery_Row_Tooltip',
        default: 3,
        max: 3,
        min: 1,
        type: 'NUMBER',
    },
    _a[optionsMap.layoutParams.groups.density] = {
        key: optionsMap.layoutParams.groups.density,
        title: 'ProGallery_Layout_CollageDens_Label',
        // description:
        //   'ProGallery_Layout_CollageDens_Tooltip',
        type: 'FLOAT',
        default: 0.8,
        min: 0,
        max: 1,
        step: 0.1,
    },
    _a[optionsMap.layoutParams.targetItemSize.value] = {
        key: optionsMap.layoutParams.targetItemSize.value,
        title: 'ProGallery_Layout_Thumbnail_Size',
        // description:
        //   'ProGallery_Layout_Thumbnail_Size_Tooltip',
        type: 'NUMBER',
        default: 48,
        min: 1,
        max: 100,
        step: 1,
    },
    _a[optionsMap.layoutParams.crop.method] = {
        key: optionsMap.layoutParams.crop.method,
        title: 'ProGallery_Layout_Thumbnail_Resize',
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        thumbnailsSize: 'MEDIUM',
        default: 'FILL',
        options: [
            {
                value: 'FILL',
                title: 'ProGallery_Layout_Thumbnail_Crop',
                icon: require('../assets/thumbnailResize/crop.svg').ReactComponent,
            },
            {
                value: 'FIT',
                title: 'ProGallery_Layout_Thumbnail_Fit',
                icon: require('../assets/thumbnailResize/fit.svg').ReactComponent,
            },
        ],
    },
    _a[optionsMap.layoutParams.crop.ratios] = {
        key: optionsMap.layoutParams.crop.ratios,
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        title: 'ProGallery_Layouts_Slider_ImageRatio_Label',
        // description:
        //   "ProGallery_Layouts_Slider_ImageRatio_Tooltip",
        default: 1,
        thumbnailsSize: 'SMALL',
        options: [
            {
                value: 16 / 9,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item1',
                icon: require('../assets/imageRatio/imageRatio_16-9.svg')
                    .ReactComponent,
            },
            {
                value: 4 / 3,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item2',
                icon: require('../assets/imageRatio/imageRatio_4-3.svg').ReactComponent,
            },
            {
                value: 1,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item3',
                icon: require('../assets/imageRatio/imageRatio_1-1.svg').ReactComponent,
            },
            {
                value: 3 / 4,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item4',
                icon: require('../assets/imageRatio/imageRatio_3-4.svg').ReactComponent,
            },
            {
                value: 9 / 16,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item5',
                icon: require('../assets/imageRatio/imageRatio_9-16.svg')
                    .ReactComponent,
            },
        ],
    },
    _a[optionsMap.layoutParams.structure.responsiveMode] = {
        key: optionsMap.layoutParams.structure.responsiveMode,
        title: 'Native_ProGallery_Layout_ResponsiveType',
        type: 'OPTIONS',
        controller: 'RADIO',
        default: 'FIT_TO_SCREEN',
        options: [
            {
                value: 'FIT_TO_SCREEN',
                title: 'ProGallery_Layouts_Grid_Responsive_Option1',
            },
            {
                value: 'SET_ITEMS_PER_ROW',
                title: 'ProGallery_Layouts_Grid_Responsive_Option2',
            },
        ],
    },
    _a[optionsMap.layoutParams.thumbnails.alignment] = {
        key: optionsMap.layoutParams.thumbnails.alignment,
        title: 'ProGallery_Layout_Layouts_Thumbnails_Placement_Label',
        type: 'OPTIONS',
        options: [
            {
                value: 'BOTTOM',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item1',
            },
            {
                value: 'TOP',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item2',
            },
            {
                value: 'RIGHT',
                title: 'Native_ProGallery_Layout_ThumbnailPlacement_List_Item3',
            },
            {
                value: 'LEFT',
                title: 'Native_ProGallery_Layout_ThumbnailPlacemento_List_Item4',
            },
        ],
        default: 'BOTTOM',
    },
    _a[optionsMap.layoutParams.thumbnails.size] = {
        key: optionsMap.layoutParams.thumbnails.size,
        title: 'ProGallery_Layout_Thumbnail_Size',
        type: 'NUMBER',
        default: 120,
        min: 80,
        max: 300,
    },
    _a[optionsMap.layoutParams.thumbnails.spacing] = {
        key: optionsMap.layoutParams.thumbnails.spacing,
        title: 'ProGallery_Layout_Layouts_Thumbnails_Spacing_Label',
        type: 'NUMBER',
        default: 4,
        min: 0,
        max: 30,
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.enable] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.enable,
        title: 'ProGallery_Layout_LoadMore_Section_Label',
        // description: 'Native_ProGallery_Layout_LoadMoreBtn_Toggle_Description',
        type: 'BOOLEAN',
        default: false,
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.text] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.text,
        title: 'ProGallery_Layout_LoadMore_Button_Title',
        // description: 'Native_ProGallery_Layout_LoadMoreBtn_Text_Description',
        type: 'TEXT',
        default: 'Load More',
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.navigationDuration] = {
        key: optionsMap.behaviourParams.gallery.horizontal.navigationDuration,
        title: 'ProGallery_Settings_Design_Scroll_Duration_Title',
        type: 'NUMBER',
        default: 800,
        min: 100,
        max: 1000,
        step: 100,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.loop] = {
        key: optionsMap.behaviourParams.gallery.horizontal.loop,
        title: 'ProGallery_Expand_Loop_Label',
        description: 'ProGallery_Expand_Loop_Tooltip',
        type: 'BOOLEAN',
        default: false,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.interval,
        title: 'ProGallery_Layout_SlideshowSection_Interval',
        // description:
        //   'Native_ProGallery_Layout_Slide_Interval_Description',
        min: 2,
        max: 30,
        type: 'NUMBER',
        default: 4,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.speed,
        title: 'ProGallery_Layout_SlideshowSection_Layout_Speed',
        // description:
        //   'ProGallery_Layout_SlideshowSection_Layout_Speed_Tooltip',
        min: 1,
        max: 500,
        type: 'NUMBER',
        default: 50,
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.pauseOnHover] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.pauseOnHover,
        title: 'ProGallery_Layout_SlideshowSection_Pause_On_Hover',
        type: 'BOOLEAN',
        default: true,
    },
    _a[optionsMap.behaviourParams.gallery.blockContextMenu] = {
        key: optionsMap.behaviourParams.gallery.blockContextMenu,
        title: 'Native_ProGallery_Settings_MediaProtection_Label',
        type: 'BOOLEAN',
        default: true,
        description: 'Native_ProGallery_Settings_MediaProtection_Tooltip',
    },
    _a[optionsMap.layoutParams.navigationArrows.enable] = {
        key: optionsMap.layoutParams.navigationArrows.enable,
        title: 'ProGallery_Design_Navigation_Arrows_Toggle',
        // description:
        //   'ProGallery_Design_Navigation_Arrows_Toggle_Tooltip',
        type: 'BOOLEAN',
        default: true,
    },
    // [optionsMap.layoutParams.navigationArrows.type]: {
    //   key: optionsMap.layoutParams.navigationArrows.type,
    //   title: 'Navigation arrows icon',
    //   description:
    //     'Choose the arrows icon for sliding gallery',
    //   type: 'OPTIONS',
    //   default: 0,
    //   options: [
    //     {
    //       value: 0,
    //       title: 'Arrow 1',
    //     },
    //     {
    //       value: 1,
    //       title: 'Arrow 2',
    //     },
    //     {
    //       value: 2,
    //       title: 'Arrow 3',
    //     },
    //   ],
    // },
    // [optionsMap.layoutParams.navigationArrows.container.type]: {
    //   key: optionsMap.layoutParams.navigationArrows.container.type,
    //   title: 'Navigation arrows styling',
    //   description:
    //     'Choose choose how you want to display the arrows',
    //   type: 'OPTIONS',
    //   default: 'SHADOW',
    //   options: [
    //     {
    //       value: 'NONE',
    //       title: 'None',
    //     },
    //     {
    //       value: 'SHADOW',
    //       title: 'Shadow',
    //     },
    //     {
    //       value: 'BOX',
    //       title: 'Box',
    //     },
    //   ],
    // },
    _a[optionsMap.layoutParams.navigationArrows.size] = {
        key: optionsMap.layoutParams.navigationArrows.size,
        title: 'ProGallery_Design_Arrows_Size',
        type: 'NUMBER',
        min: 8,
        max: 150,
        default: 23,
    },
    _a[optionsMap.layoutParams.navigationArrows.position] = {
        key: optionsMap.layoutParams.navigationArrows.position,
        title: 'ProGallery_Design_Arrows_Position_Title',
        type: 'OPTIONS',
        default: 'ON_GALLERY',
        options: [
            {
                value: 'ON_GALLERY',
                title: 'ProGallery_Design_Arrows_Position_On_Gallery',
            },
            {
                value: 'OUTSIDE_GALLERY',
                title: 'ProGallery_Design_Arrows_Position_Outside',
            },
        ],
    },
    _a[optionsMap.layoutParams.navigationArrows.verticalAlignment] = {
        key: optionsMap.layoutParams.navigationArrows.verticalAlignment,
        title: 'ProGallery_settings_design_verticalposition',
        type: 'OPTIONS',
        default: 'ITEM_CENTER',
        options: [
            {
                value: 'ITEM_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_gallery',
            },
            {
                value: 'IMAGE_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_image',
            },
            {
                value: 'INFO_CENTER',
                title: 'ProGallery_settings_design_verticalposition_center_text',
            },
        ],
    },
    _a[optionsMap.behaviourParams.item.content.hoverAnimation] = {
        key: optionsMap.behaviourParams.item.content.hoverAnimation,
        title: 'ProGallery_Design_Image_Hover_Animation_Label',
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        default: 'NO_EFFECT',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'ProGallery_Design_Image_Hover_Animation_NoEffect',
                emptyState: true,
            },
            {
                value: 'ZOOM_IN',
                title: 'ProGallery_Design_Image_Hover_Animation_ZoomIn',
                icon: require('../assets/animations/hover/zoomIn.svg').ReactComponent,
            },
            {
                value: 'BLUR',
                title: 'ProGallery_Design_Image_Hover_Animation_Blur',
                icon: require('../assets/animations/hover/blur.svg').ReactComponent,
            },
            {
                value: 'GRAYSCALE',
                title: 'ProGallery_Design_Image_Hover_Animation_Grayscale',
                icon: require('../assets/animations/hover/grayscale.svg')
                    .ReactComponent,
            },
            {
                value: 'SHRINK',
                title: 'ProGallery_Design_Image_Hover_Animation_Shrink',
                icon: require('../assets/animations/hover/shrink.svg').ReactComponent,
            },
            {
                value: 'INVERT',
                title: 'ProGallery_Design_Image_Hover_Animation_Invert',
                icon: require('../assets/animations/hover/invert.svg').ReactComponent,
            },
            {
                value: 'COLOR_IN',
                title: 'ProGallery_Design_Image_Hover_Animation_ColorIn',
                icon: require('../assets/animations/hover/color.svg').ReactComponent,
            },
            {
                value: 'DARKENED',
                title: 'ProGallery_Design_Image_Hover_Animation_Darkened',
                icon: require('../assets/animations/hover/darken.svg').ReactComponent,
            },
        ],
        description: 'ProGallery_Design_Image_Hover_Animation_Title',
    },
    _a[optionsMap.behaviourParams.item.content.loader] = {
        key: optionsMap.behaviourParams.item.content.loader,
        title: 'ProGallery_Settings_Image_Loading_Mode',
        // description: 'ProGallery_Settings_Image_Loading_Mode_TOOLTIP',
        options: [
            {
                value: 'BLUR',
                title: 'ProGallery_Settings_Image_Loading_Mode_Blur',
            },
            {
                value: 'MAIN_COLOR',
                title: 'ProGallery_Settings_Image_Loading_Mode_Color_Main_Color',
            },
        ],
        type: 'OPTIONS',
        controller: 'RADIO',
        default: 'BLUR',
    },
    _a[optionsMap.behaviourParams.item.content.placementAnimation] = {
        key: optionsMap.behaviourParams.item.content.placementAnimation,
        title: 'Image Placement Animation',
        type: 'OPTIONS',
        default: 'NO_EFFECT',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'No Effect',
            },
            {
                value: 'SLIDE',
                title: 'Slide',
            },
        ],
    },
    _a[optionsMap.behaviourParams.gallery.scrollAnimation] = {
        key: optionsMap.behaviourParams.gallery.scrollAnimation,
        title: 'ProGallery_Design_Scroll_Animation_Label',
        // description: 'ProGallery_Design_Scroll_Animation_TOOLTIP',
        controller: 'THUMBNAILS',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'ProGallery_Design_Scroll_Animation_NoEffect',
                emptyState: true,
            },
            {
                value: 'FADE_IN',
                title: 'ProGallery_Design_Scroll_Animation_FadeIn',
                icon: require('../assets/animations/scroll/fadeIn.svg').ReactComponent,
            },
            {
                value: 'GRAYSCALE',
                title: 'ProGallery_Design_Scroll_Animation_Grayscale',
                icon: require('../assets/animations/scroll/grayscale.svg')
                    .ReactComponent,
            },
            {
                value: 'SLIDE_UP',
                title: 'ProGallery_Design_Scroll_Animation_SlideUp',
                icon: require('../assets/animations/scroll/slideUp.svg').ReactComponent,
            },
            {
                value: 'EXPAND',
                title: 'ProGallery_Design_Scroll_Animation_Expand',
                icon: require('../assets/animations/scroll/expand.svg').ReactComponent,
            },
            {
                value: 'SHRINK',
                title: 'ProGallery_Design_Scroll_Animation_Shrink',
                icon: require('../assets/animations/scroll/shrink.svg').ReactComponent,
            },
            {
                value: 'ZOOM_OUT',
                title: 'ProGallery_Design_Scroll_Animation_ZoomOut',
                icon: require('../assets/animations/scroll/zoomOut.svg').ReactComponent,
            },
            {
                value: 'ONE_COLOR',
                title: 'ProGallery_Design_Scroll_Animation_OneColor',
                icon: require('../assets/animations/scroll/oneColor.svg')
                    .ReactComponent,
            },
        ],
        type: 'OPTIONS',
        default: 'NO_EFFECT',
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.slideAnimation] = {
        key: optionsMap.behaviourParams.gallery.horizontal.slideAnimation,
        title: 'ProGallery_Design_Slide_Animation_Label',
        type: 'OPTIONS',
        default: 'SCROLL',
        controller: 'THUMBNAILS',
        options: [
            {
                value: 'SCROLL',
                title: 'ProGallery_Design_Slide_Animation_Scroll',
                icon: require('../assets/animations/slide/scroll.svg').ReactComponent,
            },
            {
                value: 'FADE',
                title: 'ProGallery_Design_Slide_Animation_Fade',
                icon: require('../assets/animations/slide/fade.svg').ReactComponent,
            },
            {
                value: 'DECK',
                title: 'ProGallery_Design_Slide_Animation_Stack',
                icon: require('../assets/animations/slide/stack.svg').ReactComponent,
            },
        ],
        description: 'ProGallery_Design_Slide_Animation_Title',
    },
    _a[optionsMap.behaviourParams.item.video.enablePlayButton] = {
        key: optionsMap.behaviourParams.item.video.enablePlayButton,
        title: 'ProGallery_Settings_Show_Play_Button_Label',
        type: 'BOOLEAN',
        default: true,
    },
    _a[optionsMap.behaviourParams.item.video.playTrigger] = {
        key: optionsMap.behaviourParams.item.video.playTrigger,
        title: 'ProGallery_Settings_Play_Label',
        // description:
        //   'ProGallery_Settings_Play_Tooltip',
        options: [
            {
                value: 'HOVER',
                title: 'ProGallery_Settings_Hover_Label',
            },
            {
                value: 'AUTO',
                title: 'ProGallery_Settings_Auto_Label',
            },
            {
                value: 'CLICK',
                title: 'ProGallery_Settings_Click_Label',
            },
        ],
        type: 'OPTIONS',
        default: 'HOVER',
    },
    _a[optionsMap.behaviourParams.item.video.speed] = {
        key: optionsMap.behaviourParams.item.video.speed,
        title: 'ProGallery_Settings_Playback_Label',
        type: 'OPTIONS',
        options: [
            {
                value: 0.25,
                title: 'ProGallery_Settings_Playback_25',
            },
            {
                value: 0.5,
                title: 'ProGallery_Settings_Playback_50',
            },
            {
                value: 0.75,
                title: 'ProGallery_Settings_Playback_75',
            },
            {
                value: 1,
                title: 'ProGallery_Settings_Playback_100',
            },
            {
                value: 1.25,
                title: 'ProGallery_Settings_Playback_125',
            },
            {
                value: 1.5,
                title: 'ProGallery_Settings_Playback_150',
            },
            {
                value: 1.75,
                title: 'ProGallery_Settings_Playback_175',
            },
            {
                value: 2,
                title: 'ProGallery_Settings_Playback_200',
            },
        ],
        default: 1,
    },
    _a[PRIVATE_CONTROLLERS.VIDEO.VOLUME] = {
        key: PRIVATE_CONTROLLERS.VIDEO.VOLUME,
        title: 'ProGallery_Settings_Sound_Label',
        type: 'BOOLEAN',
        default: false,
    },
    _a[optionsMap.behaviourParams.item.video.loop] = {
        key: optionsMap.behaviourParams.item.video.loop,
        title: 'ProGallery_Settings_Loop_Label',
        // description: 'Native_ProGallery_Settings_Video_Loop_Description',
        type: 'BOOLEAN',
        default: true,
        noBottomDivider: true,
    },
    _a[optionsMap.behaviourParams.item.clickAction] = {
        key: optionsMap.behaviourParams.item.clickAction,
        title: 'ProGallery_Settings_ClickOptions_Label',
        // description:
        //   'Native_ProGallery_Settings_ItemClick_Description',
        options: [
            {
                value: 'EXPAND',
                title: 'ProGallery_Settings_ClickOptions_Expand',
            },
            {
                value: 'FULLSCREEN',
                title: 'ProGallery_Settings_ClickOptions_Fullscreen',
            },
            {
                value: 'LINK',
                title: 'ProGallery_Settings_ClickOptions_Link',
            },
            {
                value: 'NOTHING',
                title: 'ProGallery_Settings_ClickOptions_Nothing',
            },
            {
                value: 'MAGNIFY',
                title: 'ProGallery_Expand_Viewing_Settings_Magnifying',
            },
        ],
        type: 'OPTIONS',
        default: 'NOTHING',
    },
    _a[optionsMap.behaviourParams.item.content.magnificationValue] = {
        key: optionsMap.behaviourParams.item.content.magnificationValue,
        title: 'ProGallery_Expand_Viewing_Settings_Magnifying_Size',
        type: 'FLOAT',
        default: 2,
        min: 1.5,
        max: 5,
        step: 0.5,
    },
    _a[optionsMap.layoutParams.navigationArrows.padding] = {
        key: optionsMap.layoutParams.navigationArrows.padding,
        title: 'ProGallery_settings_design_Horizontal_padding',
        type: 'NUMBER',
        min: 0,
        max: 100,
        default: 23,
    },
    _a[optionsMap.behaviourParams.gallery.vertical.loadMore.amount] = {
        key: optionsMap.behaviourParams.gallery.vertical.loadMore.amount,
        title: 'ProGallery_Layout_LoadMore_Amount',
        type: 'OPTIONS',
        controller: 'RADIO',
        default: 'ALL',
        options: [
            {
                value: 'PARTIAL',
                title: 'ProGallery_Layout_LoadMore_Amount_Partial',
            },
            {
                value: 'ALL',
                title: 'ProGallery_Layout_LoadMore_Amount_All',
            },
        ],
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour] = {
        key: optionsMap.behaviourParams.gallery.horizontal.autoSlide.behaviour,
        title: 'ProGallery_Layout_SlideshowSection_Slide_Automatically',
        type: 'OPTIONS',
        default: 'OFF',
        options: [
            {
                value: 'OFF',
                title: 'Native_ProGallery_Layout_Slideshow_List_Off',
            },
            {
                value: 'INTERVAL',
                title: 'ProGallery_Layout_SlideshowSection_Interval_Header',
            },
            {
                value: 'CONTINUOUS',
                title: 'ProGallery_Layout_SlideshowSection_Continuous_Header',
            },
        ],
    },
    _a[optionsMap.behaviourParams.gallery.horizontal.slideTransition] = {
        key: optionsMap.behaviourParams.gallery.horizontal.slideTransition,
        title: 'ProGallery_Settings_Design_Slide_Transition_Title',
        // description: 'Native_ProGallery_Layout_TransitionEffect_Description',
        options: [
            {
                value: 'linear',
                title: 'ProGallery_Settings_Design_Slide_Transition_Linear',
            },
            {
                value: 'cubic-bezier(0.46,0.1,0.25,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_In_Out',
            },
            {
                value: 'cubic-bezier(0.86,0,0.5,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_In',
            },
            {
                value: 'cubic-bezier(0.31,1.17,0.58,1.07)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Ease_Out',
            },
            {
                value: 'cubic-bezier(0.49,-0.12,0.49,0.04)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_In',
            },
            {
                value: 'cubic-bezier(0.58,1.65,0.29,0.95)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_Out',
            },
            {
                value: 'cubic-bezier(0.6,-0.36,0.41,1.23)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Bounce_In_Out',
            },
            {
                value: 'cubic-bezier(0.86,0,0.07,1)',
                title: 'ProGallery_Settings_Design_Slide_Transition_Expo',
            },
        ],
        type: 'OPTIONS',
        default: 'cubic-bezier(0.46,0.1,0.25,1)',
    },
    _a[optionsMap.layoutParams.info.placement] = {
        key: optionsMap.layoutParams.info.placement,
        title: 'Native_ProGallery_Settings_Text_Placement',
        controller: 'THUMBNAILS',
        options: [
            {
                value: 'BELOW',
                title: 'Native_ProGallery_Settings_Text_Placement_Below',
                icon: require('../assets/infoPosition/below.svg').ReactComponent,
            },
            {
                value: 'ABOVE',
                title: 'Native_ProGallery_Settings_Text_Placement_Above',
                icon: require('../assets/infoPosition/above.svg').ReactComponent,
            },
            {
                value: 'RIGHT',
                title: 'Native_ProGallery_Settings_Text_Placement_Right',
                icon: require('../assets/infoPosition/right.svg').ReactComponent,
            },
            {
                value: 'LEFT',
                title: 'Native_ProGallery_Settings_Text_Placement_Left',
                icon: require('../assets/infoPosition/left.svg').ReactComponent,
            },
            {
                value: 'OVERLAY',
                title: 'Native_ProGallery_Settings_Text_Placement_Hover',
                icon: require('../assets/infoPosition/onImage.svg').ReactComponent,
            },
            // TODO - add proper icons for alternate
            {
                value: 'ALTERNATE_HORIZONTALLY',
                title: 'Native_ProGallery_Settings_Text_Placement_Alt_Horizontal',
                icon: require('../assets/infoPosition/left.svg').ReactComponent,
            },
            {
                value: 'ALTERNATE_VERTICALLY',
                title: 'Native_ProGallery_Settings_Text_Placement_Alt_Vertical',
                icon: require('../assets/infoPosition/above.svg').ReactComponent,
            },
        ],
        type: 'OPTIONS',
        default: 'OVERLAY',
    },
    _a[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE] = {
        key: PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE,
        title: 'Native_ProGallery_Settings_Text_ShowTitle',
        type: 'BOOLEAN',
        default: false,
    },
    _a[PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION] = {
        key: PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION,
        title: 'Native_ProGallery_Settings_Text_ShowDescription',
        type: 'BOOLEAN',
        default: false,
    },
    _a[PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE_AND_DESCRIPTION] = {
        key: PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE_AND_DESCRIPTION,
        title: 'Native_ProGallery_Settings_Text',
        type: 'CHECKBOX',
        options: [
            {
                title: 'Native_ProGallery_Settings_Text_Title',
                value: PRIVATE_CONTROLLERS.INFO.ALLOW_TITLE,
            },
            {
                title: 'Native_ProGallery_Settings_Text_Description',
                value: PRIVATE_CONTROLLERS.INFO.ALLOW_DESCRIPTION,
            },
        ],
        controller: 'CHECKBOX',
        default: '',
    },
    _a[PRIVATE_CONTROLLERS.INFO.EXTERNAL_MASTER_INFO_ORDER] = ExternalMasterInfoOption,
    _a[PRIVATE_CONTROLLERS.INFO.EXTERNAL_MASTER_INFO_ENABLED] = {
        default: 'Title,Description',
        key: PRIVATE_CONTROLLERS.INFO.EXTERNAL_MASTER_INFO_ENABLED,
        type: 'TEXT',
        title: ''
    },
    _a[PRIVATE_CONTROLLERS.INFO.INTERNAL_MASTER_INFO_ORDER] = InternalMasterInfoOption,
    _a[PRIVATE_CONTROLLERS.INFO.INTERNAL_MASTER_INFO_ENABLED] = {
        default: 'Title,Description',
        key: PRIVATE_CONTROLLERS.INFO.INTERNAL_MASTER_INFO_ENABLED,
        type: 'TEXT',
        title: ''
    },
    _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING] = {
        key: PRIVATE_CONTROLLERS.INFO.VERTICAL_PADDING,
        title: 'Native_ProGallery_Settings_Text_Padding_Vertical',
        type: 'NUMBER',
        min: 0,
        max: 50,
        default: 0,
    },
    _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING] = {
        key: PRIVATE_CONTROLLERS.INFO.HORIZONTAL_PADDING,
        title: 'Native_ProGallery_Settings_Text_Padding_Horizontal',
        type: 'NUMBER',
        min: 0,
        max: 50,
        default: 0,
    },
    _a[PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN] = {
        key: PRIVATE_CONTROLLERS.INFO.VERTICAL_ALIGN,
        title: 'Native_ProGallery_Settings_Text_Alignment_Vertical',
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        thumbnailsSize: 'SMALL',
        options: [
            {
                value: 'START',
                title: 'Native_ProGallery_Settings_Text_Alignment_Vertical_Top',
                icon: require('../assets/alignment/vertical/top.svg').ReactComponent,
            },
            {
                value: 'CENTER',
                title: 'Native_ProGallery_Settings_Text_Algnment_Vertical_Center',
                icon: require('../assets/alignment/center.svg').ReactComponent,
            },
            {
                value: 'END',
                title: 'Native_ProGallery_Settings_Text_Algnment_Vertical_Bottom',
                icon: require('../assets/alignment/vertical/bottom.svg').ReactComponent,
            },
        ],
        default: 'CENTER',
    },
    _a[PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN] = {
        key: PRIVATE_CONTROLLERS.INFO.HORIZONTAL_ALIGN,
        title: 'Native_ProGallery_Settings_Text_Alignment_Horizontal',
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        thumbnailsSize: 'SMALL',
        options: [
            {
                value: 'START',
                title: 'Native_ProGallery_Settings_Text_Alignment_Horizontal_Left',
                icon: require('../assets/alignment/horizontal/left.svg').ReactComponent,
            },
            {
                value: 'CENTER',
                title: 'Native_ProGallery_Settings_Text_Algnment_Horizontal_Center',
                icon: require('../assets/alignment/center.svg').ReactComponent,
            },
            {
                value: 'END',
                title: 'Native_ProGallery_Settings_Text_Algnment_Horizontal_Right',
                icon: require('../assets/alignment/horizontal/right.svg')
                    .ReactComponent,
            },
        ],
        default: 'CENTER',
    },
    _a[optionsMap.layoutParams.info.sizeUnits] = {
        key: optionsMap.layoutParams.info.sizeUnits,
        title: 'Native_ProGallery_Settings_Text_Size',
        options: [
            { value: 'PIXEL', title: 'Native_ProGallery_Settings_Text_Size_Pixels' },
            {
                value: 'PERCENT',
                title: 'Native_ProGallery_Settings_Text_Size_Percentage',
            },
        ],
        type: 'OPTIONS',
        default: 'PIXEL',
    },
    _a[optionsMap.layoutParams.info.height] = {
        key: optionsMap.layoutParams.info.height,
        title: 'Native_ProGallery_Settings_Text_Size_Height_Pixels',
        type: 'NUMBER',
        min: 1,
        max: 800,
        default: 200,
    },
    _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL] = {
        key: PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PIXEL,
        title: 'Native_ProGallery_Settings_Text_Size_Width_Pixels',
        type: 'NUMBER',
        min: 100,
        max: 1000,
        default: 200,
    },
    _a[PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT] = {
        key: PRIVATE_CONTROLLERS.INFO.WIDTH_IN_PERCENT,
        title: 'Native_ProGallery_Settings_Text_Size_Width_Percentage',
        type: 'NUMBER',
        min: 20,
        max: 90,
        default: 50,
    },
    _a[optionsMap.behaviourParams.item.overlay.hoveringBehaviour] = {
        key: optionsMap.behaviourParams.item.overlay.hoveringBehaviour,
        title: 'Native_ProGallery_Settings_Text_Overlay',
        options: [
            {
                value: 'APPEARS',
                title: 'Native_ProGallery_Settings_Text_Overlay_Appears',
            },
            {
                value: 'DISAPPEARS',
                title: 'Native_ProGallery_Settings_Text_Overlay_Disappears',
            },
            {
                value: 'NO_CHANGE',
                title: 'Native_ProGallery_Settings_Text_Overlay_Nothing',
            },
            {
                value: 'NEVER_SHOW',
                title: 'Native_ProGallery_Settings_Text_Overlay_Never',
            },
        ],
        type: 'OPTIONS',
        default: 'NEVER_SHOW',
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.OVERLAY_TYPE,
        title: 'Native_ProGallery_Settings_Text_Overlay',
        options: [
            { value: 'FULL', title: 'Native_ProGallery_Settings_Text_Overlay_Full' },
            {
                value: 'PARTIAL',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial',
            },
        ],
        type: 'OPTIONS',
        default: 'FULL',
    },
    _a[optionsMap.behaviourParams.item.overlay.sizeUnits] = {
        key: optionsMap.behaviourParams.item.overlay.sizeUnits,
        title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Size_Set',
        options: [
            {
                value: 'PIXEL',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Size_Pixel',
            },
            {
                value: 'PERCENT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Size_Percentage',
            },
        ],
        type: 'OPTIONS',
        default: 'PERCENT',
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PERCENT,
        title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Set_Percentage',
        type: 'NUMBER',
        min: 0,
        max: 100,
        default: 100,
    },
    _a[PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL] = {
        key: PRIVATE_CONTROLLERS.OVERLAY.SIZE_IN_PIXEL,
        title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Set_Pixels',
        type: 'NUMBER',
        min: 0,
        max: 1000,
        default: 100,
    },
    _a[optionsMap.behaviourParams.item.overlay.position] = {
        key: optionsMap.behaviourParams.item.overlay.position,
        title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position',
        options: [
            {
                value: 'LEFT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Left',
            },
            {
                value: 'RIGHT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Right',
            },
            {
                value: 'BOTTOM',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Bottom',
            },
            {
                value: 'TOP',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Top',
            },
            {
                value: 'CENTERED_VERTICALLY',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Center_Vertical',
            },
            {
                value: 'CENTERED_HORIZONTALLY',
                title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Position_Center_Horizontal',
            },
        ],
        type: 'OPTIONS',
        default: 'BOTTOM',
    },
    _a[optionsMap.behaviourParams.item.overlay.padding] = {
        key: optionsMap.behaviourParams.item.overlay.padding,
        title: 'Native_ProGallery_Settings_Text_Overlay_Partial_Padding',
        type: 'NUMBER',
        min: 0,
        max: 200,
        default: 0,
    },
    _a[optionsMap.behaviourParams.item.overlay.hoverAnimation] = {
        key: optionsMap.behaviourParams.item.overlay.hoverAnimation,
        title: 'Native_ProGallery_Settings_Text_Overlay_Hover',
        controller: 'THUMBNAILS',
        options: [
            {
                value: 'NO_EFFECT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Nothing',
                emptyState: true,
            },
            {
                value: 'EXPAND',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Expand',
                icon: require('../assets/animations/overlay/expand.svg').ReactComponent,
            },
            {
                value: 'FADE_IN',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_FadeIn',
                icon: require('../assets/animations/overlay/fadeIn.svg').ReactComponent,
            },
            {
                value: 'SLIDE_UP',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Slide_Up',
                icon: require('../assets/animations/overlay/slideUp.svg')
                    .ReactComponent,
            },
            {
                value: 'SLIDE_RIGHT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Slide_Right',
                icon: require('../assets/animations/overlay/slideRight.svg')
                    .ReactComponent,
            },
            {
                value: 'SLIDE_DOWN',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Slide_Down',
                icon: require('../assets/animations/overlay/slideDown.svg')
                    .ReactComponent,
            },
            {
                value: 'SLIDE_LEFT',
                title: 'Native_ProGallery_Settings_Text_Overlay_Hover_Slide_Left',
                icon: require('../assets/animations/overlay/slideLeft.svg')
                    .ReactComponent,
            },
        ],
        type: 'OPTIONS',
        default: 'NO_EFFECT',
    },
    _a[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_METHOD] = {
        key: PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_METHOD,
        title: 'Native_ProGallery_GalleryRatio',
        type: 'OPTIONS',
        controller: 'RADIO',
        thumbnailsSize: 'MEDIUM',
        default: 'MANUAL',
        options: [
            {
                value: 'MANUAL',
                title: 'Native_ProGallery_GalleryRatio_Option1',
            },
            {
                value: 'FIXED',
                title: 'Native_ProGallery_GalleryRatio_Option2',
            },
        ],
        description: 'Native_ProGallery_GalleryRatio_Tooltip',
    },
    _a[PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_VALUE] = {
        key: PRIVATE_CONTROLLERS.GALLERY.GALLERY_RATIO_VALUE,
        type: 'OPTIONS',
        controller: 'THUMBNAILS',
        // title: 'Native_ProGallery_GalleryRatio_Value_Label',
        // description: 'Native_ProGallery_GalleryRatio_Value_Tooltip',
        default: 1,
        thumbnailsSize: 'SMALL',
        options: [
            {
                value: 3 / 1,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item0',
                icon: require('../assets/imageRatio/imageRatio_3-1.svg')
                    .ReactComponent,
            },
            {
                value: 16 / 9,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item1',
                icon: require('../assets/imageRatio/imageRatio_16-9.svg')
                    .ReactComponent,
            },
            {
                value: 4 / 3,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item2',
                icon: require('../assets/imageRatio/imageRatio_4-3.svg').ReactComponent,
            },
            {
                value: 1,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item3',
                icon: require('../assets/imageRatio/imageRatio_1-1.svg').ReactComponent,
            },
            {
                value: 3 / 4,
                title: 'Native_ProGallery_Layout_CropRatio_List_Item4',
                icon: require('../assets/imageRatio/imageRatio_3-4.svg').ReactComponent,
            },
        ],
    },
    _a);
export var ProFullscreenOptions = (_b = {},
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_TITLE] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_TITLE,
        title: 'MISSING_Allow title',
        description: 'MISSING_Allow title',
        type: 'BOOLEAN',
        default: true,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_DESCRIPTION] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_DESCRIPTION,
        title: 'MISSING_Allow description',
        description: 'MISSING_Allow description',
        type: 'BOOLEAN',
        default: true,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_LINK] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_LINK,
        title: 'MISSING_Allow link',
        description: 'MISSING_Native_ProGallery_Layout_LoadMoreBtn_Toggle_Description',
        type: 'BOOLEAN',
        default: false,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.EXPAND_INFO_POSITION] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.EXPAND_INFO_POSITION,
        title: 'MISSING_Info position',
        type: 'OPTIONS',
        default: 'SIDE',
        options: [
            {
                value: 'BOTTOM',
                title: 'MISSING_BOTTOM',
            },
            {
                value: 'SIDE',
                title: 'MISSING_SIDE',
            },
        ],
        description: 'MISSING_Info position',
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.SHOW_INFO_BUTTON] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.SHOW_INFO_BUTTON,
        title: 'MISSING_Toggle info',
        description: 'MISSING_Toggle info',
        type: 'BOOLEAN',
        default: false,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_FULLSCREEN_EXPAND] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_FULLSCREEN_EXPAND,
        title: 'MISSING_Allow fullscreen',
        description: 'MISSING_Allow fullscreen',
        type: 'BOOLEAN',
        default: true,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.LOOP] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.LOOP,
        title: 'MISSING_Loop images',
        description: 'MISSING_Loop images',
        type: 'BOOLEAN',
        default: false,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_MAGNIFY_IMAGE] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.ALLOW_MAGNIFY_IMAGE,
        title: 'MISSING_Allow magnification',
        description: 'MISSING_Allow magnification',
        type: 'BOOLEAN',
        default: false,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.MAGNIFICATION_LEVEL] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.MAGNIFICATION_LEVEL,
        title: 'MISSING_Magnification value',
        description: 'MISSING_Magnification value',
        type: 'NUMBER',
        min: 1,
        max: 5,
        step: 1,
        default: 2,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_BLUR_FILTER] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_BLUR_FILTER,
        title: 'MISSING_Background blur filter',
        description: 'MISSING_Background blur filter',
        type: 'NUMBER',
        min: 1,
        max: 20,
        step: 1,
        default: 1,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.BACKGROUND_GRAYSCAL_EFILTER,
        title: 'MISSING_Background Grayscale filter',
        description: 'MISSING_Background Grayscale filter',
        type: 'BOOLEAN',
        default: false,
    },
    _b[PRIVATE_CONTROLLERS.FULLSCREEN.FULLSCREEN_PREVIEW] = {
        key: PRIVATE_CONTROLLERS.FULLSCREEN.FULLSCREEN_PREVIEW,
        title: 'Fullscreen Preview',
        type: 'VIEWPORT',
        default: '',
        component: function (props) {
            return React.createElement(require('../components/fullscreen/fullscreenPreviewWrapper').default, { options: props.options }, "Fullscreen Viewer");
        },
    },
    _b);
export var ProGallerySettingsOptions = __assign(__assign(__assign({}, EditorSections), GalleryOptions), ProFullscreenOptions);
//# sourceMappingURL=ProGallery.options.js.map